module.exports = __webpack_public_path__ + "static/img/model-1.1d9163d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phoneHomePage/model-1.gif
// module id = OGQj
// module chunks = 0